class OnlineService {
  constructor() {
    this.isOnline = typeof navigator !== 'undefined' ? navigator.onLine : true;
    this.lastProbeAt = 0;
    this.probePromise = null;
    this.probeCooldownMs = 15000;
    this.probeTimeoutMs = 1500;

    if (typeof window !== 'undefined') {
      this.onOnline = () => {
        this.isOnline = true;
      };

      this.onOffline = () => {
        this.isOnline = false;
      };

      window.addEventListener('online', this.onOnline);
      window.addEventListener('offline', this.onOffline);
    }
  }

  markOnline() {
    this.isOnline = true;
  }

  markOffline() {
    this.isOnline = false;
  }

  async probeConnectivity() {
    const now = Date.now();

    if (this.probePromise && now - this.lastProbeAt < this.probeCooldownMs) {
      return this.probePromise;
    }

    if (now - this.lastProbeAt < this.probeCooldownMs) {
      return this.isOnline;
    }

    this.lastProbeAt = now;

    const apiHost = process.env.VUE_APP_API_ENDPOINT || window.location.origin;
    const probeUrl = `${apiHost}/dij`;

    this.probePromise = new Promise((resolve) => {
      const controller = new AbortController();
      const timeoutId = setTimeout(() => {
        controller.abort();
      }, this.probeTimeoutMs);

      fetch(probeUrl, {
        method: 'HEAD',
        cache: 'no-store',
        signal: controller.signal,
      })
        .then(() => {
          this.isOnline = true;
          resolve(true);
        })
        .catch(() => {
          this.isOnline = false;
          resolve(false);
        })
        .finally(() => {
          clearTimeout(timeoutId);
          this.probePromise = null;
        });
    });

    return this.probePromise;
  }

  async getStatus() {
    if (
      typeof navigator !== 'undefined' &&
      navigator.onLine !== this.isOnline
    ) {
      this.isOnline = navigator.onLine;
    }

    if (typeof navigator !== 'undefined' && !navigator.onLine) {
      this.isOnline = false;
      return false;
    }

    if (!this.isOnline) {
      return this.probeConnectivity();
    }

    return this.isOnline;
  }
}

export default new OnlineService();
